import axios from 'axios'
import store from '../vuex/store'
let baseUrl = process.env.BASE_API
function post(url, params = {}, type = 0, isLoad = true,method = 'post') {
    return new Promise((resolve, reject) => {
        //localStorage.getItem('isSp')==1 判断是否是SP后台，以下接口需要用connect接口
        if(url.indexOf('beconnect_api')>-1||url.indexOf('db_exec')>-1||url.indexOf('/trans')>-1||url.indexOf('/onlinete')>-1||url.indexOf('/sendmail')>-1){
            //TE 后台接口
            switch (process.env.NODE_ENV) {
                case 'development':
                    baseUrl = "https://connect.be.co:4000"//开发环境url
                    // baseUrl = "http://localhost:3030"//开发环境url
                    // baseUrl = "http://101.132.176.175:3030"//开发环境url
                    break
                case 'production':
                    baseUrl = "https://connect.be.co:4000"   //生产环境url=
                    break
                case 'testing':
                    baseUrl = "https://connect.be.co:4000"//测试环境url
                break
            }
        }else if((url.indexOf('/admin')>-1)&&store.state.isSp==1){
            baseUrl = "https://api.schoolsguide.com.cn"
        }else if(url.indexOf('/tesystem')>-1){
            baseUrl = "https://te.be.co"
        }else{
            //BE connect 后台接口
            switch (process.env.NODE_ENV) {
                case 'development':
                    baseUrl = "https://connect.be.co:8200"
                    break
                case 'production':
                    // baseUrl = "http://47.97.163.66:8100"   //生产环境url
                    baseUrl = "https://connect.be.co:8200"
                    break
                case 'testing':
                    baseUrl = "https://connect.be.co:8200"   //测试环境url
                break
            }
        }
        if (isLoad) {
            store.commit('SET_SPIN',true)
        }
        var token = "1",
            endUrl, header;
        header = {
            "Content-Type": "application/json;charset=UTF-8"
        }
        endUrl = baseUrl + url;
        if (type == 1) {
            var index = 0;
            for (var i in params) {
                if (index == 0) {
                    endUrl = endUrl + '?' + i + '=' + params[i];
                } else {
                    endUrl = endUrl + '&' + i + '=' + params[i];
                }
                index++;
            }
            params = null;
        }
        header.token = token;
        axios({
            method: method,
            url: endUrl,
            processData: false,
            contentType: 'application/json;charset=UTF-8',
            headers: header,
            timeout: 40000,
            data: params
        }).then(res => {
            if (isLoad){
                store.state.isGlobalSpin = false
            }
            if(url.indexOf('/trans')>-1){
                var data = res.data
                if (data.Code == 0) {
                    resolve(data.data)
                } else {
                    reject(data);
                }
            }else{
                var data = res.data
                if (data.code == 0) {
                    resolve(data.result)
                } else {
                    reject(data);
                }
            }
        }).catch(err => {
            if (isLoad){
                store.state.isGlobalSpin = false
            }
            reject(err);
        })
    })
}
export default post;


// WEBPACK FOOTER //
// ./src/utils/config.js